import { TabPanel, TabView, TabViewTabChangeEvent } from 'primereact/tabview';
import { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

import styles from './CertificateDetailsTabView.module.css';
import DetailsTab from './tabs/details-tab/DetailsTab';
import PermissionsTab from './tabs/permissions-tab/PermissionsTab';

const TABS = ['details', 'permissions'];

const CertificateDetailsTabView = (): JSX.Element => {
  const { certificateId } = useParams() as { certificateId: string };
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  const activeTabIndex = useMemo(() => {
    const pathSegments = location.pathname.split('/');
    const activeTab = pathSegments[pathSegments.length - 1];

    return Math.max(TABS.indexOf(activeTab), 0);
  }, [location.pathname]);

  // Redirect to details tab (first tab) if the URL doesn't contain a valid tab
  useEffect(() => {
    const pathSegments = location.pathname.split('/');
    const activeTab = pathSegments[pathSegments.length - 1];
    if (TABS.indexOf(activeTab) === -1 && certificateId) {
      navigate(`/certificates/my-certificates/${certificateId}/details`, { replace: true });
    }
  }, [location.pathname, navigate, certificateId]);

  const handleTabChange = (event: TabViewTabChangeEvent) => {
    const href = `/certificates/my-certificates/${certificateId}/${TABS[event.index]}`;

    navigate(href);
  };

  return (
    <TabView
      className={styles['certificate-details-tab-view']}
      pt={{
        nav: { className: 'flex flex-row gap-6' },
      }}
      activeIndex={activeTabIndex}
      onTabChange={handleTabChange}
    >
      <TabPanel header={t('certificateDetailsPage.tabs.detailsTab.tabHeader')}>
        <DetailsTab />
      </TabPanel>

      <TabPanel header={t('certificateDetailsPage.tabs.permissionsTab.tabHeader')}>
        <PermissionsTab />
      </TabPanel>
    </TabView>
  );
};

export default CertificateDetailsTabView;
